<template>
  <form>
    <div
      class="custom-label-tighter mb-6 flex items-center font-medium"
      v-if="!success && message"
      :style="messageStyle"
    >
      <!-- <svg width="16" height="16" class="mr-3">
        <use xlink:href="#tick-16x16" />
      </svg> -->
      <span class="flex-grow" v-text="message"></span>
    </div>

    <slot v-if="success" name="success"></slot>

    <slot v-if="!success" v-bind:isDisabled="isDisabled" />
  </form>
</template>
<script>
import Vue from 'vue'
import lazyRecaptcha from '../../lib/lazy-recaptcha'

export default {
  name: 'AsyncForm',
  data() {
    return {
      message: '',
      success: null,
      isDisabled: false,
      captchaLoaded: false,
    }
  },
  methods: {
    handleSubmit() {
      const formData = new FormData(this.$el)

      for (let [key, value] of formData.entries()) {
        const input = this.$el[key]

        // if several inputs with same name but all are hidden except one
        if (NodeList.prototype.isPrototypeOf(input)) {
          for (let i = 0; i < input.length; i++) {
            if (input[i].parentElement.offsetParent) {
              formData.set(key, input[i].value)
            }
          }
        } else {
          // if input's parent block is set to display: none, exclude this input from payload
          // we are checking parent block and not input itself because of custom selects: they are hidden, but must not be excluded
          if (!input.parentElement.offsetParent) {
            formData.delete(key)
          }
        }
      }

      const payload = new URLSearchParams(formData).toString()

      this.isDisabled = true
      fetch(this.$el.getAttribute('action'), {
        method: this.$el.getAttribute('method'),
        body: payload,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }).then((response) => {
        this.isDisabled = false

        response.json().then((json) => {
          this.success = response.status < 400 && json.success
          this.message = json.message || (this.success ? 'Success' : 'Error')
          if (this.success && this.onSuccess) {
            this.onSuccess()
            Vue.nextTick(() => {
              this.$el.scrollIntoView({ block: 'center', behavior: 'smooth' })
            })
          }
        })
      })
    },
    initCaptchaIfNotYet() {
      if (!this.captchaLoaded) {
        this.captchaLoaded = true
        lazyRecaptcha.protectForm(this.$el, this.handleSubmit)
      }
    },
    updateScroll() {
      const { smoothScroll } = this.$store.state
      if (smoothScroll) {
        Vue.nextTick(() => {
          smoothScroll.update()
        })
      }
    },
  },
  computed: {
    messageStyle() {
      return this.success === false ? { color: 'red' } : null
    },
  },
  props: {
    onSuccess: {
      type: Function,
      default: () => {},
    },
  },
  mounted() {
    for (let i = 0; i < this.$el.elements.length; i++) {
      this.$el.elements[i].addEventListener('focus', this.initCaptchaIfNotYet)
      this.$el.addEventListener('click', this.initCaptchaIfNotYet)
    }
  },
  watch: {
    success() {
      this.updateScroll()
    },
    message() {
      this.updateScroll()
    },
  },
}
</script>
